import { global_hooks } from 'src/globals';

global_hooks.on('init', init);
function init() {
	if (document.querySelector('.slide_menu_open')) {
		import('./slide_menu');
	}
}
